import ErrorReporter from "@soenergy/frontend-library/src/services/ErrorReporter"
import GatewayPortalV2 from "@soenergy/frontend-library/src/services/api/GatewayPortalV2"

export const productRateTypes = {
  timeOfUse: "TOU",
}

export const namespaced = true
const getDefaultState = () => {
  return {
    agreements: null,
  }
}

export const state = getDefaultState()

export const mutations = {
  SET_AGREEMENTS(state, agreements) {
    state.agreements = agreements
  },
}

export const actions = {
  async fetchAgreements({ state, commit, rootState }, forceFetch = false) {
    if (state.agreements && !forceFetch) {
      return
    }
    try {
      const { data } = await GatewayPortalV2.getAgreements(
        rootState.currentAccount
      )
      commit("SET_AGREEMENTS", data)
    } catch (err) {
      ErrorReporter.report(err)
      throw err
    }
  },
}

export const getters = {
  getAllAgreements(state) {
    return state.agreements ?? []
  },

  getAgreementsForMeterpointIdentifier: (state) => (meterpointIdentifier) => {
    return (
      state.agreements?.filter(
        (agreement) => agreement.meterpointIdentifier === meterpointIdentifier
      ) ?? []
    )
  },

  getActiveAgreements(state) {
    return state.agreements?.filter((agreement) => agreement.isActive) ?? []
  },

  getFutureAgreements(state) {
    return (
      state.agreements?.filter((agreement) => agreement.startsInFuture) ?? []
    )
  },

  getEstimatedAnnualCost(state) {
    return state.agreements
      .filter((agreement) => agreement.isActive && !agreement.startsInFuture)
      .reduce((total, agreement) => total + agreement.costPerYearInPounds, 0)
  },

  hasAgreementWithTouProduct(state) {
    return !!state.agreements?.some(
      (agreement) =>
        (agreement.isActive || agreement.startsInFuture) &&
        agreement.productRateType === productRateTypes.timeOfUse
    )
  },

  hasActiveAgreements(state) {
    return !!state.agreements?.some((agreement) => agreement.isActive)
  },

  hasActiveExportAgreements(_state, getters) {
    return getters.getActiveAgreements.some(
      (agreement) => agreement.isExportTariff
    )
  },
}
